export const SMAI_LOGO = "/images/logo-graphic-over-text-lg.png";
export const EAI_LOGO_GRAPHIC_OVER_TEXT = "/images/logo-graphic-over-text-lg.png";
export const EAI_LOGO_GRAPHIC_ONLY = "/images/logo-graphic-only-lg.png";
export const EAI_LOGO_GRAPHIC_SPARKING = "/images/Avatar.svg";
export const SMAI_BG = "/images/background.png";
export const CogIcon = "./icons/CogIcon.svg";
export const AnalyticsIcon = "./icons/AnalyticsIcon.svg";
export const ProspectsIcon = "./icons/ProspectsIcon.svg";
export const EngagementIcon = "./icons/MailIcon.svg";
export const ConversationsIcon = "./icons/ConversationsIcon.svg";
export const StarIcon = "../static/icons/StarIcon.svg";
export const ExportIcon = "./icons/ExportIcon.svg";
export const GRAPHQL_URL = process.env.GATSBY_API_URL || "http://localhost:5000/graphql";
export const SOCKET_URL = process.env.GATSBY_WS_API_URL;
export const V1_SOCKET_URL = process.env.GATSBY_V1_SOCKET_URL || "http://localhost:5000/graphql";

// ---------------------------------------------------------------------------
// OttoVin (EngagedAI's vehicle-discovery product) integration.
// OTTOVIN_URL: base of the OttoVin web app for this environment.
// OTTOVIN_LOCATION_TOKENS: location-scoped ANONYMOUS OttoVin tokens keyed by
// numeric locationId (JSON via GATSBY_OTTOVIN_LOCATION_TOKENS). These are
// public-capability tokens — the same exposure class as a printed QR code:
// they grant only customer-visible content for one location, no lead/user
// attribution. When a location has a token, links open the location-scoped
// page (guarantees the right rooftop's listing); otherwise we fall back to the
// anonymous bare-VIN page.
// ---------------------------------------------------------------------------
export const OTTOVIN_URL =
  process.env.GATSBY_OTTOVIN_URL ||
  (process.env.GATSBY_APP_ENVIRONMENT === "prod"
    ? "https://ottovin.com"
    : "https://stage.ottovin.com");

export const OTTOVIN_LOCATION_TOKENS = (() => {
  try {
    return JSON.parse(process.env.GATSBY_OTTOVIN_LOCATION_TOKENS || "{}");
  } catch (e) {
    return {};
  }
})();

// BUILD_SHEET_URL: base of the OEM build-sheet service, whose
// `/v1/build-sheets/<VIN>.pdf` path is PUBLIC (anonymous OEM marketing data, no
// auth) and — unlike OttoVin's own `/api/build-sheet-pdf` relay — sends no
// X-Frame-Options, so the Content Status viewer can frame it directly. See
// resolveCellViewUrl in components/inventory/documents/contentActions.js.
// Prod is intentionally unset until the host is confirmed: with no value the
// viewer keeps using the URL OttoVin sends, which frames once that route sends
// `CSP: frame-ancestors` (the proper fix, tracked in ottovin-webapp).
export const BUILD_SHEET_URL =
  process.env.GATSBY_BUILD_SHEET_URL ||
  (process.env.GATSBY_APP_ENVIRONMENT === "prod" ? "" : "https://build-sheets-stage.engagedai.io");

/** OttoVin vehicle-page URL for a row: tokenized when the location has a
 *  configured token, anonymous bare-VIN otherwise. */
export const ottoVinVehicleUrl = (vin, locationId) => {
  const token = OTTOVIN_LOCATION_TOKENS[String(locationId)];
  return token
    ? `${OTTOVIN_URL}/${encodeURIComponent(token)}?vin=${encodeURIComponent(vin)}`
    : `${OTTOVIN_URL}/${encodeURIComponent(vin)}`;
};
export const SadIcon = "/images/sad.png";
export const SMAI_MAIL = "support@engagedai.com";
export const PROJECT_NAME = "EngagedAI";
export const PROJECT_NAME_V2 = "EngagedAi";

export const DEFAULT_COUNTRY = "US";

export const COPY_RIGHTS =
  "2017-2023 All Rights Reserved. EngagedAi is a registered trademark of EngagedAi, Inc.";

export const ServiceTypes = [
  { name: "GENERAL", value: "GENERAL" },
  { name: "ACTIVITY CENTER", value: "ACTIVITY_CENTER" },
  { name: "CAMPAIGN", value: "CAMPAIGN" },
  { name: "APPOINTMENT", value: "APPOINTMENT" },
];

export const timeMappings = [
  { value: "00:00:00", name: "12:00AM" },
  { value: "01:00:00", name: "1:00AM" },
  { value: "02:00:00", name: "2:00AM" },
  { value: "03:00:00", name: "3:00AM" },
  { value: "04:00:00", name: "4:00AM" },
  { value: "05:00:00", name: "5:00AM" },
  { value: "06:00:00", name: "6:00AM" },
  { value: "07:00:00", name: "7:00AM" },
  { value: "08:00:00", name: "8:00AM" },
  { value: "09:00:00", name: "9:00AM" },
  { value: "10:00:00", name: "10:00AM" },
  { value: "11:00:00", name: "11:00AM" },
  { value: "12:00:00", name: "12:00PM" },
  { value: "13:00:00", name: "1:00PM" },
  { value: "14:00:00", name: "2:00PM" },
  { value: "15:00:00", name: "3:00PM" },
  { value: "16:00:00", name: "4:00PM" },
  { value: "17:00:00", name: "5:00PM" },
  { value: "18:00:00", name: "6:00PM" },
  { value: "19:00:00", name: "7:00PM" },
  { value: "20:00:00", name: "8:00PM" },
  { value: "21:00:00", name: "9:00PM" },
  { value: "22:00:00", name: "10:00PM" },
  { value: "23:00:00", name: "11:00PM" },
];

export const colorCode = {
  WAITING_FOR_LEAD_RESPONSE: "#EA580C",
  WAITING_FOR_DEALER_RESPONSE: "#2563EB",
  UNCONTACTED: "#D97706",
  MY_CONVERSATION: "#7C3AED",
  NO_RESPONSE_NEEDED: "#DC2626",
  ENGAGED: "#16a34a",
  POSITIVE: "#389E0D",
  NEGATIVE: "#FF4D4F",
};

export const titleCode = {
  RESPONDED: "Responded",
  WAITING_FOR_REPLY: "Waiting for Reply",
  UNCONTACTED: "Uncontacted",
};

export const BASE_URL_FOR_STATIC_ICONS_AND_IMAGES =
  "https://smai-public.s3.amazonaws.com/dev/assets";

// all the icons url
export const AddIcon = "/icons/AddIcon.svg";
export const AddItemIcon1 = "/icons/AddItemIcon1.svg";
export const AddNoteIcon = "/icons/AddNoteIcon.svg";
export const AddResponseIcon = "/icons/AddResponseIcon.svg";
export const AddSignatureIcon = "/icons/AddSignatureIcon.svg";
export const AirplaneIcon = "/icons/AirplaneIcon.svg";
export const AirplaneIconWhite = "/icons/AirplaneIconWhite.svg";
export const Analytics_Icon = "/icons/AnalyticsIcon.svg";
export const Avatar = "/icons/Avatar.svg";
export const BellIcon = "/icons/BellIcon.svg";
export const BellIconBlue = "/icons/BellIconBlue.svg";
export const BillingIcon = "/icons/BillingIcon.svg";
export const BotIcon = "/icons/BotIcon.svg";
export const CalendarIcon = "/icons/CalendarIcon.svg";
export const ChatIcon = "/icons/ChatIcon.svg";
export const ChatIcon2 = "/icons/ChatIcon2.svg";
export const ChatIconWhite = "/icons/ChatIconWhite.svg";
export const CheckIcon = "/icons/CheckIcon.svg";
export const CheckIconBlue = "/icons/CheckIconBlue.svg";
export const CloseIcon = "/icons/CloseIcon.svg";
export const CloseIconBlue = "/icons/CloseIconBlue.svg";
export const Cog_Icon = "/icons/CogIcon.svg";
export const ColdIcon = "/icons/ColdIcon.svg";
export const CompanyIcon = "/icons/CompanyIcon.svg";
export const ContactIcon = "/icons/ContactIcon.svg";
export const Conversations_Icon = "/icons/ConversationsIcon.svg";
export const CraiglistIcon = "/icons/CraiglistIcon.svg";
export const CreditIcon = "/icons/CreditIcon.svg";
export const CRMIcon = "/icons/CRMIcon.svg";
export const CSVIcon = "/icons/CSVIcon.svg";
export const DealerraterIcon = "/icons/DealerraterIcon.svg";
export const DownloadContractTemplate = "/icons/DownloadContractTemplate.svg";
export const EditIcon = "/icons/EditIcon.svg";
export const EditIcon2 = "/icons/EditIcon2.svg";
export const ExploreIcon = "/icons/ExploreIcon.svg";
export const Export_Icon = "/icons/ExportIcon.svg";
export const FacebookIcon = "/icons/FacebookIcon.svg";
export const FacebookIconCircleFilledBlue = "/icons/FacebookIconCircleFilledBlue.svg";
export const FacebooksIcon = "/icons/FacebooksIcon.svg";
export const FilterIcon1 = "/icons/FilterIcon1.svg";
export const FilterIcon2 = "/icons/FilterIcon2.svg";
export const GoogleIcon = "/icons/GoogleIcon.svg";
export const GraphColor = "/icons/GraphColor.svg";
export const GraphIcon = "/icons/GraphIcon.svg";
export const HandshakeIcon = "/icons/HandshakeIcon.svg";
export const HotIcon = "/icons/HotIcon.svg";
export const InstagramIcon = "/icons/InstagramIcon.svg";
export const LifeEventsIcn = "/icons/LifeEventsIcn.svg";
export const LinkedinIcon = "/icons/LinkedinIcon.svg";
export const LinkIcon = "/icons/LinkIcon.svg";
export const LinkIcon2 = "/icons/LinkIcon2.svg";
export const LocationIcon = "/icons/LocationIcon.svg";
export const LocationIcon2 = "/icons/LocationIcon2.svg";
export const MailIcon = "/icons/MailIcon.svg";
export const ManageTeamIcon = "/icons/ManageTeamIcon.svg";
export const PhoneIcon = "/icons/PhoneIcon.svg";
export const PostIcon = "/icons/PostIcon.svg";
export const Prospects_Icon = "/icons/ProspectsIcon.svg";
export const RedditIcon = "/icons/RedditIcon.svg";
export const RemoteCallIcon = "/icons/RemoteCallIcon.svg";
export const RemoveActive = "/icons/RemoveActive.svg";
export const RemoveIcon = "/icons/RemoveIcon.svg";
export const ResponseIcon = "/icons/ResponseIcon.svg";
export const ResponseIconWhite = "/icons/ResponseIconWhite.svg";
export const ScreenNameIcon = "/icons/ScreenNameIcon.svg";
export const SignatureIcon = "/icons/SignatureIcon.svg";
export const SocialMediaIcon = "/icons/SocialMediaIcon.svg";
export const Star_Icon = "/icons/StarIcon.svg";
export const StarIconActive = "/icons/StarIconActive.svg";
export const StarIconWhite = "/icons/StarIconWhite.svg";
export const TwitterIcon = "/icons/TwitterIcon.svg";
export const UploadIcon = "/icons/UploadIcon.svg";
export const UserRolesIcon = "/icons/UserRolesIcon.svg";
export const WarmIcon = "/icons/WarmIcon.svg";
export const WarmIcon2 = "/icons/WarmIcon2.svg";
export const XLSIcon = "/icons/XLSIcon.svg";
export const XMLIcon = "/icons/XMLIcon.svg";
export const YelpIcon = "/icons/YelpIcon.svg";

// All the smai logos url
export const logo = "/logos/logo.png";
export const funnelai_logo = "/logos/funnelai_logo.png";
export const Logo2_PNG = "/logos/Logo2.png";
export const Logo2_SVG = "/logos/Logo2.svg";
export const tribu_logo_login_area = "/logos/tribu_logo-login-area.png";
export const Logo = "/logos/Logo.svg";

// All the images url
export const autotrader = "/images/sources/autotrader.png";
export const calendar = "/images/sources/calendar.png";
export const cars_com = "/images/sources/cars-com.png";
export const craigslist = "/images/sources/craigslist.png";
export const facebook = "/images/sources/facebook.png";
export const forum = "/images/sources/forum.png";
export const fresh_up = "/images/sources/fresh up.png";
export const instagram = "/images/sources/instagram.png";
export const linkedin = "/images/sources/linkedin.png";
export const marketplace = "/images/sources/marketplace.png";
export const phone_up = "/images/sources/phone up.png";
export const quora = "/images/sources/quora.png";
export const reddit = "/images/sources/reddit.png";
export const twitter = "/images/sources/twitter.png";
export const unknown = "/images/sources/unknown.png";
export const privacy_policy = "/images/privacy-policy.png";
export const background = "/images/background.png";
export const avatar1 = "/images/avatar1.png";

export const CampaignEventTypes = [
  { name: "AUTOMATED", label: "Price Drop" },
  { name: "AUTO_RESPONSE", label: "Auto Responder" },
];

export const Durations = [
  { name: "HOURS", label: "Hours" },
  { name: "DAYS", label: "Days" },
  { name: "WEEKS", label: "Weeks" },
  { name: "MONTH", label: "Months" },
];

export const CoolDownDays = [
  { name: "1", label: "1" },
  { name: "2", label: "2" },
  { name: "3", label: "3" },
  { name: "4", label: "4" },
  { name: "5", label: "5" },
  { name: "6", label: "6" },
  { name: "7", label: "7" },
  { name: "8", label: "8" },
  { name: "9", label: "9" },
  { name: "10", label: "10" },
  { name: "11", label: "11" },
  { name: "12", label: "12" },
];

export const DurationMints = [
  { name: "5", label: "5 mins" },
  { name: "10", label: "10 mins" },
  { name: "15", label: "15 mins" },
  { name: "20", label: "20 mins" },
  { name: "25", label: "25 mins" },
  { name: "30", label: "30 mins" },
  { name: "35", label: "35 mins" },
  { name: "40", label: "40 mins" },
  { name: "45", label: "45 mins" },
  { name: "50", label: "50 mins" },
  { name: "55", label: "55 mins" },
  { name: "60", label: "60 mins" },
];
